import {
  ColorPicker as SharedColorPicker,
  CustomColorInput as SharedCustomColorInput,
} from '@thefinpedia/thefinpedia-shared/canvas';
import { addIcon, eyeDropperIcon } from '../../../../assets/images/canvas';

const iconProps = { eyeDropperIcon, addColorIcon: addIcon };

export const ColorPicker = (props) => (
  <SharedColorPicker {...iconProps} {...props} />
);

export const CustomColorInput = (props) => (
  <SharedCustomColorInput {...iconProps} {...props} />
);
